export const GET_ADMINISTRATIVE_INCIDENTS = 'GET_ADMINISTRATIVE_INCIDENTS';
export const FLAG_GETTING_ADMINISTRATIVE_INCIDENTS =
  'FLAG_GETTING_ADMINISTRATIVE_INCIDENTS';
export const CLEAR_ADMINISTRATIVE_INCIDENTS = 'CLEAR_ADMINISTRATIVE_INCIDENTS';

export const ACTIVITY_ADMINISTRATIVE_INCIDENT = 'ACTIVITY_ADMINISTRATIVE_INCIDENT';